'use client'

import { useTenantButtonColor } from '@/components/TenantButtonColorContext'
import { ctaButtonColorStyle } from '@/lib/colorUtils'
import { FC } from 'react'

export interface SPBottomSectionProps {
  ctaUrl?: string | null
  ctaLabel?: string | null
  /**
   * 「別の動画へ」押下時の処理。undefined なら左ボタンを出さず、CTAが全幅になる
   * （動画個別ページで関連動画が0本のとき）。
   */
  onShowCarousel?: () => void
  onCTAClick: () => void
  /**
   * CTA を `<a target="_blank">` で描く（通常のWebページ向け）。
   * 既定の false は埋め込みプレイヤー向けで、`<button>` を描き遷移は onCTAClick 側が担う。
   */
  ctaAsLink?: boolean
}

/**
 * SP 最下段の「別の動画へ｜CTA」2列。埋め込み SP モーダルと動画個別ページの SP で共有し、
 * 見た目（比率・gap・角丸・既定の青グラデ／テナント色）をここ1箇所に集約する。
 */
const SPBottomSection: FC<SPBottomSectionProps> = ({
  ctaUrl,
  ctaLabel,
  onShowCarousel,
  onCTAClick,
  ctaAsLink = false,
}) => {
  const ctaStyle = ctaButtonColorStyle(useTenantButtonColor())
  const ctaContent = <span className="sp-cta-button-text">{ctaLabel || '採用情報へ'}</span>
  return (
    <>
      <style>{`
        .sp-bottom-section {
          flex-shrink: 0;
          /* background: #000; */
          padding: 2px 12px 0px;
          padding-bottom: 8px;
          animation: spBottomSlideUp 500ms ease-out;
        }

        .sp-powered-by {
          margin: 8px;
          text-align: center;
          color: rgba(255, 255, 255, 0.8);
          font-size: 11px;
          letter-spacing: 0.3px;
        }

        @keyframes spBottomSlideUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .sp-button-row {
          display: flex;
          gap: 12px;
        }

        .sp-cta-button {
          flex: 1;
          padding: 12px;
          background: var(--video-brand-color, var(--video-accent-color, #1d48af));
          color: white;
          font-size: 15px;
          font-weight: bold;
          border: none;
          border-radius: 10px;
          cursor: pointer;
          text-align: center;
        }

        /* <a> で描くとき（ctaAsLink）も <button> と同じ中央寄せ・同じ文字色にする */
        a.sp-cta-button {
          display: flex;
          align-items: center;
          justify-content: center;
          text-decoration: none;
        }
        a.sp-cta-button:hover,
        a.sp-cta-button:focus-visible {
          color: white;
          text-decoration: none;
        }

        .sp-cta-button:hover {
          background: var(--video-brand-hover-color, var(--video-accent-hover-color, #17398c));
        }

        .sp-cta-button-text {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 1.4;
        }

        .sp-another-button {
          flex: 1;
          padding: 12px;
          background: rgba(255,255,255,0.1);
          color: white;
          font-size: 15px;
          font-weight: bold;
          border: 1px solid rgba(255,255,255,0.3);
          border-radius: 10px;
          cursor: pointer;
        }
      `}</style>

      <div className="sp-bottom-section">
        <div className="sp-button-row">
          {onShowCarousel && (
            <button type="button" className="sp-another-button" onClick={onShowCarousel}>
              別の動画へ
            </button>
          )}
          {ctaUrl &&
            (ctaAsLink ? (
              <a
                href={ctaUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="sp-cta-button"
                style={ctaStyle}
                onClick={onCTAClick}
              >
                {ctaContent}
              </a>
            ) : (
              <button type="button" className="sp-cta-button" style={ctaStyle} onClick={onCTAClick}>
                {ctaContent}
              </button>
            ))}
        </div>
      </div>
    </>
  )
}

export default SPBottomSection
